import {Project} from "../api/Project";

export const galleryKitProject: Project = {
    id: 6,
    title: 'GalleryKit',
    description: 'GalleryKit is simplest / beautiful and smartest gallery picker',
    link: 'https://github.com/chirag-ji/GalleryKit',
    image: 'https://github.githubassets.com/pinned-octocat.svg',
    startDate: 'September 2020',
    completeDate: 'September 2020',
    hidden: false,
    technologies: {
        frontend: undefined,
        backend: [
            'Android',
        ]
    },
};
